module.exports = __webpack_public_path__ + "img/clothing91.8aed5231.jpg";